import { Link } from 'react-router-dom';
import { Logo } from '../components/Logo';

/**
 * Customer sign-in page — acts as the public home page.
 * Large invoice-variant logo ABOVE the auth card.
 */
export default function CustomerLogin() {
  const startGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/portal';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex flex-col relative overflow-hidden bg-white">
      {/* Subtle red glow in corners — keeps the logo area pure white */}
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            'radial-gradient(circle at 100% 100%, rgba(217,32,39,0.06), transparent 35%), radial-gradient(circle at 0% 100%, rgba(217,32,39,0.05), transparent 35%)',
        }}
      />
      {/* Thin accent bar at the very top */}
      <div aria-hidden className="h-[3px] w-full bg-[#d92027] relative z-10" />

      <main className="flex-1 flex items-center justify-center px-5 py-10 sm:py-14 relative z-10">
        <div className="w-full max-w-md">
          {/* Big logo — sits above the login card */}
          <div className="hidden sm:flex justify-center mb-8">
            <Logo size="3xl" variant="invoice" />
          </div>
          <div className="flex sm:hidden justify-center mb-6">
            <Logo size="2xl" variant="invoice" />
          </div>

          {/* Auth card */}
          <div className="bg-white border border-[#eaeaea] rounded-2xl p-6 sm:p-8 shadow-[0_20px_40px_-24px_rgba(0,0,0,0.12)]">
            <div className="text-center mb-6">
              <h1 className="text-2xl font-semibold tracking-tight mb-2">Customer Portal</h1>
              <p className="text-[13px] text-[#6b7280] leading-relaxed">
                Sign in with your Google account to view invoices, place orders, and pay online.
              </p>
            </div>
            <button
              onClick={startGoogleLogin}
              className="w-full btn-google justify-center"
              data-testid="customer-google-signin"
            >
              <svg width="18" height="18" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12s5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24s8.955,20,20,20s20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"/>
                <path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"/>
                <path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"/>
                <path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"/>
              </svg>
              Continue with Google
            </button>
            <p className="text-[11px] text-[#9ca3af] mt-5 text-center leading-relaxed">
              By continuing, you agree to OttoMed's terms of service.
            </p>
          </div>

          {/* Discreet admin entry */}
          <p className="text-center text-[11px] text-[#9ca3af] mt-6">
            Admin?{' '}
            <Link
              to="/admin/login"
              className="text-[#9ca3af] hover:text-[#0a0a0a] underline underline-offset-2 transition-colors"
              data-testid="admin-login-link"
            >
              Sign in here
            </Link>
          </p>
        </div>
      </main>

      {/* Footer */}
      <footer className="relative z-10 border-t border-[#eaeaea]">
        <div className="max-w-5xl mx-auto px-5 py-5 text-center text-[11px] text-[#9ca3af]">
          © {new Date().getFullYear()} OttoMed · New York, NY ·{' '}
          <a href="mailto:billing@ottomed.org" className="hover:text-[#d92027]">billing@ottomed.org</a>
        </div>
      </footer>
    </div>
  );
}
